import React, { useCallback, useEffect, useRef, useState } from 'react';

import { DotLottieReact, setWasmUrl } from '@lottiefiles/dotlottie-react';
import Lottie from 'react-lottie';

setWasmUrl('/dotlottie-player.wasm');

const LottieHoverPlayer = ({ animationData, options, speed = 1 }) => {
  const dotLottieRef = useRef(null);
  const [animationState, setAnimationState] = useState({ isStopped: true, isPaused: false });
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    setHydrated(true);
  }, []);

  const handleMouseEnter = useCallback(() => {
    if (typeof animationData === 'string') {
      dotLottieRef.current?.play();
    } else {
      setAnimationState({ isStopped: false, isPaused: false });
    }
  }, [animationData]);

  const handleMouseLeave = useCallback(() => {
    if (typeof animationData === 'string') {
      dotLottieRef.current?.stop();
    } else {
      setAnimationState({ isStopped: true, isPaused: false });
    }
  }, [animationData]);

  if (!hydrated) return null;

  if (typeof animationData === 'string') {
    return (
      <div style={{ width: '100%', height: '100%' }} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        <DotLottieReact
          src={animationData}
          loop
          autoplay={false}
          speed={speed}
          style={{ width: '100%', height: '100%' }}
          dotLottieRefCallback={(ref) => {
            dotLottieRef.current = ref;
          }}
        />
      </div>
    );
  }

  return (
    <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <Lottie
        options={{ ...options, autoplay: false, animationData }}
        isStopped={animationState.isStopped}
        isPaused={animationState.isPaused}
        speed={speed}
      />
    </div>
  );
};

export default React.memo(LottieHoverPlayer);
